package com.kinoshazam.uiKit.components.videoItem

fun String?.normalizedRating(): String? {
    val value = this?.trim().orEmpty()
    if (value.isEmpty()) return null
    if (value.equals("N/A", ignoreCase = true)) return null
    if (value == "0" || value == "0.0") return null
    return value
}
